import { Component, OnInit } from '@angular/core';

@Component({
    template: `
    <re-alert type="danger" [dismissible]="false"><strong>{{ message }}</strong></re-alert>
  `,
    standalone: false
})
export class NotFoundComponent implements OnInit {
  message: string;
  ngOnInit() {
    this.message = 'The requested resource does not exist.';
  }
}
